
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1673_254)"}},[_c('path',{attrs:{"d":"M17.424 19.96l-4.907-2.962a1 1 0 00-1.034 0L6.576 19.96l1.302-5.583a1 1 0 00-.319-.982L3.223 9.638l5.709-.484a1 1 0 00.836-.606L12 3.28l2.232 5.267a1 1 0 00.836.606l5.709.484-4.336 3.757a1 1 0 00-.32.982l1.303 5.583z","fill":"#F0F0F0","stroke":"#CCC"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1673_254"}},[_c('rect',{attrs:{"width":"24","height":"24","rx":".5","fill":"#fff"}})])])])
          )
        }
      }
    